export default __webpack_public_path__ + "static/media/93ca4aa6ada8fe9d9a7e92c9e03eda99.jpg";